// @flow
import axios from 'axios';
import type { AxiosXHRConfigBase } from 'axios';
import { getBaseUrl } from 'utils/DOM';

export type XWSResponse = {
  /**
   * False if the request failed on the server (should be 500 but it's a 200
   * with success: false)
   */
  success: boolean,
  /**
   * Internal status code
   */
  statusCode: number,
  /**
   * Internal key
   */
  key?: string,
  /**
   * A message if the request fails
   */
  message?: string
};

function createClient() {
  const baseURL = getBaseUrl();
  const config: AxiosXHRConfigBase<any, XWSResponse> = {
    baseURL,
    responseType: 'json',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };
  const client = axios.create(config);

  function throwGenericError(response, message?: string) {
    let computedMessage = `request to ${response.config.url} failed`;
    if (!message) {
      computedMessage += ' with no message';
    } else {
      computedMessage += ` with message: ${message}`;
    }
    throw new Error(computedMessage);
  }

  client.interceptors.response.use(function(response) {
    if (!response.data) {
      throwGenericError(response);
    }
    // xws api returns false if the request failed
    const data: XWSResponse = (response.data: any);
    if (!data.success) {
      throwGenericError(response, data.message || '');
    }
    return response;
  });

  return client;
}

const xwsClient = createClient();

export type XWSMeta = {|
  /**
   * True to instruct the API to send mock data, the API consumer
   * is in control of using this prop to send mock data
   */
  useMock?: boolean
|};

export default xwsClient;



// WEBPACK FOOTER //
// ./src/api/clients/xws.js